<!--
 * @Author: lidan
 * @Date: 2020-10-13 09:21:01
 * @LastEditTime: 2020-10-13 15:53:22
 * @LastEditors: Please set LastEditors
 * @Description: 开票信息组件
 * @FilePath: \e6-module-tax-service\src\e6-module-tax-service\views\invoiceManage\components\invoiceInfo.vue
-->
<template>
  <div>
    <div
      class="invoiceInfo"
      v-for="(invoiceItem, index) in invoiceInfoData"
      :key="index"
    >
      <div class="title">
        <span class="title-bold">{{ invoiceItem.invoiceType }}</span>
        <span
          class="title-data"
          v-for="(item, index) in invoiceInfoTitleLabel"
          :key="index"
        >
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ invoiceItem[item.labelName] }}</span>
        </span>
      </div>
      <div class="main">
        <div
          class="item"
          v-for="(item, index) in invoiceInfoMainLabel"
          :key="index"
        >
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ invoiceItem[item.labelName] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "invoiceInfo",
  props: [
    "invoiceInfoData", //发票信息数据全部（后台返回）
    "invoiceInfoTitleLabel", //标题的label（键值对结构的键）
    "invoiceInfoMainLabel" //主体的label（键值对结构的键）
  ]
};
</script>

<style lang="scss" scoped>
@import "../styles/dialog.scss";
/deep/ {
  //开票信息部分
  .invoiceInfo {
    border-bottom: 1px solid #edf0f5;
    padding-bottom: 8px;
  }
}
</style>
